<template>
	<footer
		class="bg-gray text-center text-lg-start"
		style="background-color: #929fba">
		<!-- <img
            class="decoration-city"
            src="/images/zinc/decoration-city.svg"
            alt="alternative"
        /> -->
		<div class="container p-4 pb-0">
			<section class=".d-md-none .d-lg-block">
				<div class="ts-grid is-stackable is-relaxed">
					<div class="column is-2-wide"></div>

					<div class="column is-4-wide">
						<h4
							class="ts-text is-uppercased is-big is-center-aligned footer-title">
							{{ $t("footer.clientInfo") }}
						</h4>
						<hr />
						<div class="footer-info">
							<p class="ip">IP: {{ $page.props.IP }}</p>
							<p class="iplocate in" v-if="$page.props.in_school">
								&nbsp;
								<span
									class="ts-icon is-graduation-cap-icon"></span>

								{{ $t("footer.inCampus") }}
							</p>
							<p class="iplocate out" v-else>
								&nbsp;
								<span
									class="ts-icon is-triangle-exclamation-icon"></span>

								{{ $t("footer.outCampus") }}
							</p>
						</div>
						<p class="footer-info">
							{{ $t("footer.os") }}:
							{{ browser.os }}
						</p>
						<p class="footer-info">
							{{ $t("footer.useArchitecture") }}
							{{ $page.props.user_bit }} {{ $t("footer.bit") }}
						</p>
					</div>

					<div class="column is-3-wide">
						<h4
							class="ts-text is-uppercased is-big is-center-aligned footer-title">
							{{ $t("footer.relatedWebsites") }}
						</h4>
						<hr />
						<p class="footer-info">
							<a
								class=""
								href="https://www.ncu.edu.tw"
								target="_blank"
								:title="
									$t('goto') +
									' ' +
									$t('NCU') +
									' ' +
									$t('website')
								">
								{{ $t("NCU") }}
							</a>
						</p>

						<p class="footer-info">
							<a
								class=""
								href="https://www.cc.ncu.edu.tw"
								target="_blank"
								:title="
									$t('goto') +
									' ' +
									$t('NCUCC') +
									' ' +
									$t('website')
								">
								{{ $t("NCUCC") }}
							</a>
						</p>

						<p class="footer-info">
							<a
								class=""
								href="https://www.cc.ncu.edu.tw/p/412-1000-159.php"
								target="_blank"
								:title="$t('footer.privacy')">
								{{ $t("footer.privacy") }}
							</a>
						</p>
					</div>

					<div class="column is-5-wide">
						<div class="ts-image is-centered">
							<img
								class="footer-image"
								src="/img/logo.webp"
								alt="NCU Logo" />
						</div>
						<p class="ts-text is-center-aligned footer-info">
							<span class="ts-icon is-location-arrow-icon"></span>
							&nbsp;
							<a
								class=""
								href="https://goo.gl/maps/FEgNsx8hn3hpKBqLA"
								target="_blank"
								:title="$t('newTab') + $t('footer.address')">
								{{ $t("footer.address") }}
							</a>
						</p>
						<p class="ts-text is-center-aligned footer-info">
							<span class="ts-icon is-phone-icon"></span>
							&nbsp;
							{{ $t("footer.telephone") }}
						</p>
						<p class="ts-text is-center-aligned footer-info">
							<span class="ts-icon is-circle-info-icon"></span>
							&nbsp;
							<InertiaLink class="" href="/about">
								{{ $t("aboutUs") }}
							</InertiaLink>
						</p>
					</div>
				</div>
			</section>
		</div>

		<div
			class="text-center mt-2 p-1"
			style="background-color: #747f95; color: #141414">
			Copyright © 2022
			{{ $t("NCUCCFull2") }}
			{{ $t("homepage.copyright") }}
		</div>
	</footer>
</template>

<script>
import { detect } from "detect-browser";

export default {
	data() {
		const browser = detect();
		return {
			browser,
		};
	},
	mounted() {},
};
</script>

<style scoped>
.iplocate {
	display: inline;
}
.ip {
	display: inline;
}

.footer-title {
	color: var(--ts-gray-900);
	margin-left: auto;
	margin-right: auto;
}

.footer-image {
	max-width: 70%;
	margin-top: 0.65rem;
	margin-bottom: 1rem;
}
p.iplocate.in {
	color: #5c005c;
}
p.iplocate.out {
	color: #ffc107;
}

a {
	color: #303030;
	font-weight: 350;
	text-decoration: none;
}

a:hover {
	color: #040404;
}
.footer-info {
	font-weight: 300;
	margin-top: 0.65rem;
	margin-bottom: 0.45rem;
}

.footer_title {
	size: 28px;
	text-transform: uppercase;
	text-align: center;
}
</style>
